import React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Paper } from '@mui/material';
import ListAppContentPages from '../app-content/list-app-content-pages.component';
import ListAppContentFAQs from '../app-content/list-app-content-faqs.component';

const AppWebsiteContent = ({ channelDetail, viewMode }) => (
  <Box component={Paper} p={2} width="100%">
    <Divider textAlign="center" variant="fullWidth" sx={{ fontWeight: 'bold' }}>
      Website Pages
    </Divider>

    <ListAppContentPages channelId={channelDetail.id} viewMode={viewMode} />

    <Divider
      textAlign="center"
      variant="fullWidth"
      sx={{ fontWeight: 'bold', mt: 7 }}
    >
      Website FAQs
    </Divider>

    <ListAppContentFAQs channelId={channelDetail.id} viewMode={viewMode} />
  </Box>
);

AppWebsiteContent.propTypes = {
  channelDetail: PropTypes.object.isRequired,
  viewMode: PropTypes.bool,
};
AppWebsiteContent.defaultProps = {
  viewMode: false,
};

export default AppWebsiteContent;
